import FeatureKeys from "global/constants/FeatureKeys";
import { canAddTemplates, canUseTemplates } from "../predicates";
import type { TourStepConfig } from "../../types/tour.types";

const CREATE_BUTTON_WAIT_MS = 1500;

export const templatesSteps: TourStepConfig[] = [
  {
    id: "templates-create",
    target: "templates.create",
    title: "Create a template or folder",
    content:
      "Turn a document you send often into a template, or add a folder to group the ones you already have.",
    placement: "left",
    targetWaitTimeout: CREATE_BUTTON_WAIT_MS,
    when: canAddTemplates,
  },
  {
    id: "templates-reuse",
    target: "templates.content",
    fallbackTargets: ["templates.header"],
    title: "Your saved templates",
    content: (ctx) =>
      ctx.hasFeature(FeatureKeys.ENVELOPE_WEB_FORMS)
        ? "Start a request from any of these with recipients and fields already in place — or publish one as a form anyone can open and sign."
        : "Start a request from any of these with the recipients and fields already in place, instead of building it again.",
    placement: "bottom",
    when: canUseTemplates,
  },
];

export default templatesSteps;
